var React = require('react');
var Gender = require('./gender');
var Shopify = require('./shopify');

module.exports = React.createClass({


  componentDidMount: function() {
  	document.title = "Womens - Ingledew's Shoes";
  },

  render: function() {

  	return <Gender gender="Womens" tbi_title={CMS.womens.title} tbi_text={CMS.womens.text}
                   tbi_btnText={CMS.womens.btnText} tbi_btnLink={CMS.womens.btnLink}
                   tbi_image={CMS.womens.img} tbi_imageM={CMS.womens.imgM}
                   promo1={CMS.womens.promo1} promo1_img={CMS.womens.promo1_img}
                   promo2={CMS.womens.promo2} promo2_img={CMS.womens.promo2_img}
                   promo3={CMS.womens.promo3} promo3_img={CMS.womens.promo3_img}
                   promo4={CMS.womens.promo4} promo4_img={CMS.womens.promo4_img}
                   promo5={CMS.womens.promo5} promo5_img={CMS.womens.promo5_img}
                   promo6={CMS.womens.promo6} promo6_img={CMS.womens.promo6_img}
                   menus={CMS.womens.categories} />
  }
});